import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import useAppInitialization from "./hooks/useAppInitialization";
import ProtectedRoute from "./components/ProtectedRoute";
import Loader from "./components/Elements/Loader";
import ErrorPage from "./components/Pages/ErrorPage";
import EnvironmentBrsrReport from "./components/Form/ProjectsForm/EnvironmentBrsrReport/EnviromentBrsrReport";
import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { logout, setSessionExpired } from "./redux/auth/authSlice";
import PopupCard from "./pages/Auth/PopupCard";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Dashboard } from "./pages";
import AddQuestions from "./pages/Organization/components/AddQuestionBank/AddQuestion";
import { Login, SignUp } from "./pages/Auth";
import ResetPasswords from "./pages/Auth/ResetPasswords";
import { SessionLogin } from "./pages/Auth/SessionLogin";
import { LoginEmployee } from "./pages/Auth/LoginEmployee";
import OrganizationProjects from "./pages/Organization/components/Projects/Projects";
import OrganizationUsers from "./pages/Organization/components/Users/Users";
import EmployeeRoutes from "./pages/Employee/employeeRoutes";
import OrganizationRoutes from "./pages/Organization/organizationRoutes";
import { isPublicRoute } from "./utils/config/helper/checkPublicRoute";
import YourQuestion from "./pages/Organization/components/MyQuestionBank/YourQuestion";
import DynamicForm from "../src/pages/Organization/components/DynamicForm/DynamicForm";
import EditDynamicForm from "./pages/Organization/components/DynamicForm/EditDynamicForm.js/EditDynamicForm";
import SubSections from "./pages/Organization/components/MyQuestionBank/SubSections";
import { ConfigProvider, Layout } from "antd";
import Divisions from "./pages/Organization/components/MyQuestionBank/Divisions";
import RolesPage from "./pages/Organization/components/Roles/Roles";
import "antd/dist/reset.css";
import ProjectPage from "./pages/Organization/components/Projects/ProjectPage/ProjectPage";
import StandardForm from "./pages/Organization/components/Projects/StandardForm/StandardForm";
import Questions from "./pages/Organization/components/MyQuestionBank/Questions";
import ViewForm from "./components/Pages/ViewForm";
import AssignedForms from "./pages/Organization/components/AssignedForms/AssignedForms";
import Support from "./pages/Organization/components/Support/Support";
import CreateNewTickets from "./pages/Organization/components/Support/CreateNewTickets/CreateNewTickets";
import SupportAction from "./pages/Organization/components/Support/SupportAction/SupportAction";
import FormAssigned from "./pages/Employee/components/FormAssigned/FormAssigned";
import IndividualFootprintCalculator from "./pages/Employee/components/IndividualFootprintCalculator/IndividualFootprintCalculator";
import IndividualFootprintDashboard from "./pages/Employee/components/IndividualFootprintDashboard/IndividualFootprintDashboard";
import Profile from "./pages/Organization/components/Users/Profile/Profile";
import LicenseAccess from "./pages/Organization/components/Users/Profile/LicenseAccess/LicenseAccess";
import LocationUser from "./pages/Organization/components/LocationUser/LocationUser";
import EmissionTracking from "./pages/Organization/components/Dashboard/EmissionTracking";
import EnvironmentalImpact from "./pages/Organization/components/Dashboard/EnvironmentImpact/index";
import Social from "./pages/Organization/components/Dashboard/Social/Social";
import Governance from "./pages/Organization/components/Dashboard/Governance";
import SupplyChain from "./pages/Organization/components/Dashboard/Social/SupplyChain/SupplyChain";
import SDG from "./pages/Organization/components/Dashboard/SDG";
import UserDetailPage from "./pages/Organization/components/common/UserDetailPage/UserDetailPage";
import Home from "./pages/Organization/components/Home/Home";
import ViewAllQuestions from "./pages/Organization/components/AllQuestions/ViewAllQuestions";
import ViewStandardForm from "./pages/Organization/components/ViewForm/ViewStandardForm";
import AssignFormDetail from "./pages/Organization/components/ViewForm/AssignFormDetail";
import ViewDynamicForm from "./pages/Organization/components/ViewDynamicForm/ViewDynamicForm";
import EmpProfile from "./pages/Employee/components/employeeprofile/EmpProfile";
import AddManualQuestions from "./pages/Organization/components/AddManualQuestionBank/AddManualQuestions";
import { OrgDashboard } from "./pages/Organization/components/Dashboard/OrgDashboard";
import StaticPage from "./pages/Static/StaticPage";
import PoliciesPage from "./pages/Static/PoliciesPage";
import Footer from "./pages/Organization/components/Dashboard/common/Footer";
import Logins from "./pages/Auth/logins";
import ResetPasswordForm from "./pages/Auth/ResetPasswordForm";
import AssignFormPage from "./pages/Organization/components/Projects/ProjectPage/AssignFormPage";
import AuthorizeToManage from "./pages/Organization/components/Projects/ProjectPage/AuthorizeToManage";
import HierarchyPage from "./pages/Organization/components/Projects/StandardForm/HierarchyPage";
import ManageForms from "./pages/Organization/components/ManageForms/ManageForms";
import RolesPages from "./pages/Employee/components/Roles/RolesPages";
import OrganizationSetup from "./pages/Organization/components/OrganizationSetup/OrganizationSetup";
import ImportLocation from "./pages/Organization/components/LocationAndDepartment/Location/ImportLocation";
import ImportDepartment from "./pages/Organization/components/LocationAndDepartment/Department/ImportDepartment";
import ImportUsers from "./pages/Organization/components/Users/DailogBoxes/ImportUsers";

import LocationAndDepartment from "./pages/Organization/components/LocationAndDepartment/LocationAndDepartment";
import LicenseAcces from "./pages/Employee/components/employeeprofile/LicenseAccess/LicenseAcces";
import EmpLocationUsers from "./pages/Employee/components/LocationUser/EmpLocationUsers";
import EmpViewStandardForm from "./pages/Employee/components/ViewForm/EmpViewStandardForm";
import ResetPasswordsemployee from "./pages/Auth/ResetPasswordsemployee";
import StandardFormAction from "./pages/Organization/components/ViewForm/StandardFormAction";
import SetNewEmployeePassword from "./pages/Employee/components/ResetPassword/SetNewEmployeePassword";
import EmpUserAssignFormDetail from "./pages/Employee/components/ViewForm/EmpUserAssignFormDetail";
import UserAssignFormDetail from "./pages/Organization/components/ViewForm/UserAssignFormDetail";
import ResetPasswordModal from "./components/ResetPasswordModal";
const { Content } = Layout;

const EmployeeManageForms = () => (
  <ManageForms basePath="/employee/manage-form/view" enableEmployeeApi={true} />
);

const ImportLocationPage = ({ isMapping }) => {
  const navigate = useNavigate();
  return (
    <ImportLocation
      isMapping={isMapping}
      onClose={() => navigate("/organization/organization-setup")}
    />
  );
};

const ImportDepartmentPage = ({ isMapping }) => {
  const navigate = useNavigate();
  return (
    <ImportDepartment
      isMapping={isMapping}
      onClose={() => navigate("/organization/organization-setup")}
    />
  );
};

const ImportUsersPage = ({ isMapping }) => {
  const navigate = useNavigate();
  return (
    <ImportUsers
      isMapping={isMapping}
      onClose={() => navigate("/organization/user-management")}
    />
  );
};

function App() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loading.loading);
  const user = useSelector((state) => state.auth.user);
  const sessionExpired = useSelector((state) => state.auth.sessionExpired);
  const { isLoggedIn } = useAppInitialization();
  const location = useLocation();

  const renderProtectedRoute = (path, Component, access) => (
    <Route
      path={path}
      element={
        <ProtectedRoute access={access}>
          <Component />
        </ProtectedRoute>
      }
    />
  );

  // Check if current route should show footer (for employee routes and public routes)
  const shouldShowFooter =
    location.pathname !== "/organization/login" &&
    location.pathname !== "/reset-password" &&
    location.pathname !== "/resetPasswordForm" &&
    !location.pathname.startsWith("/employee/login/") &&
    !location.pathname.startsWith("/organization/");

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Lexend, sans-serif",
        },
      }}
    >
      <Layout className="flex min-h-96">
        {/* <ToastContainer /> */}
        <Toaster reverseOrder={false} />
        <ErrorBoundary fallbackRender={ErrorPage}>
          {!isPublicRoute(location.pathname) && loading && (
            <Loader loading={loading} text="Loading, please wait..." />
          )}
          <ResetPasswordModal />

          <Content className="w-full">
            <Routes>
              {/* Public Routes */}
              <Route path="/policies" element={<PoliciesPage />} />
              <Route path="/static/:type" element={<StaticPage />} />
              {/* <Route path="/organization/login" element={<Login />} /> */}
              <Route path="/organization/login" element={<Logins />} />

              <Route path="/organization/sign-up" element={<SignUp />} />
              <Route
                path="/employee/login/:orgId"
                element={<LoginEmployee />}
              />
              <Route
                path="/employee/resetpassword"
                element={<ResetPasswordsemployee />}
              />
              <Route
                path="/employee/reset-password"
                element={<SetNewEmployeePassword />}
              />
              <Route
                path="/employee/reset-password/:token"
                element={<SetNewEmployeePassword />}
              />
              {/* <Route
                path="employee/form-assigned/view/:templateId"
                element={<EmpViewStandardForm/>}
              /> */}

              <Route path="/reset-password" element={<ResetPasswords />} />
              {/* <Route path="/resetPasswordForm" element={< ResetPasswordForm />} />
               */}

              <Route path="/products" element={<EnvironmentBrsrReport />} />
              <Route path="/switch/:token" element={<SessionLogin />} />
              {/* /organization/home */}

              {/* Employee Routes */}
              <Route
                path="/employee/*"
                element={
                  isLoggedIn ? (
                    <EmployeeRoutes />
                  ) : (
                    <Navigate to="/employee/login" replace />
                  )
                }
              >
                {renderProtectedRoute("home", Home, ["employee"])},
                {renderProtectedRoute("profile", EmpProfile, ["employee"])},
                {renderProtectedRoute("role", RolesPages, ["employee"])},
                {renderProtectedRoute("license", LicenseAcces, ["employee"])},
                {renderProtectedRoute("empLocationUsers", EmpLocationUsers, [
                  "employee",
                ])}
                ,
                {/* {renderProtectedRoute("empLocationUser", EmpLocationUser, ["employee"])}, */}
                {/* {renderProtectedRoute("licens", LicenseAccess, ["employee"])}, */}
                {renderProtectedRoute("dashboard", Dashboard, ["employee"])},
                {renderProtectedRoute("form-assigned", FormAssigned, [
                  "employee",
                ])}
                {renderProtectedRoute("manage-form", EmployeeManageForms, [
                  "employee",
                ])}
                {renderProtectedRoute(
                  "manage-form/view/:formId",
                  ViewStandardForm,
                  ["employee"],
                )}
                {renderProtectedRoute(
                  "manage-form/user-details/view/:formId",
                  EmpUserAssignFormDetail,
                  ["employee"],
                )}
                {renderProtectedRoute(
                  "form-assigned/view/:templateId", // ✅ match the path
                  EmpViewStandardForm,
                  ["employee"],
                )}
                {renderProtectedRoute(
                  "individual-footprint-calculator",
                  IndividualFootprintCalculator,
                  ["employee"],
                )}
                {renderProtectedRoute(
                  "individual-footprint-dashboard",
                  IndividualFootprintDashboard,
                  ["employee"],
                )}
              </Route>

              {/* Organization Routes - Footer is handled inside OrganizationRoutes */}
              <Route
                path="/organization/*"
                element={
                  isLoggedIn ? (
                    <OrganizationRoutes />
                  ) : (
                    <Navigate to="/organization/login" replace />
                  )
                }
              >
                {renderProtectedRoute("dashboard", OrgDashboard, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "dashboard/emission-tracking",
                  EmissionTracking,
                  ["organisation"],
                )}

                {renderProtectedRoute("dashboard/governance", Governance, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "organization/Department",
                  LocationAndDepartment,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "projects/assign-form/:id",
                  AssignFormPage,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "projects/authorize-form/:id",
                  AuthorizeToManage,
                  ["organisation"],
                )}

                {renderProtectedRoute("dashboard/sdg", SDG, ["organisation"])}
                {renderProtectedRoute("view", ViewAllQuestions, [
                  "organisation",
                ])}
                {renderProtectedRoute("add-questions/:formId", AddQuestions, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "add-manualquestions/:formId",
                  AddManualQuestions,
                  ["organisation"],
                )}

                {renderProtectedRoute(
                  "dashboard/environmental-impact",
                  EnvironmentalImpact,
                  ["organisation"],
                )}
                {renderProtectedRoute("dashboard/social", Social, [
                  "organisation",
                ])}
                {renderProtectedRoute("dashboard/supply-chain", SupplyChain, [
                  "organisation",
                ])}
                {renderProtectedRoute("projects", OrganizationProjects, [
                  "organisation",
                ])}
                {renderProtectedRoute("projects/projectPage", ProjectPage, [
                  "organisation",
                ])}
                {renderProtectedRoute("assigned-form/view/:formId", ViewForm, [
                  "organisation",
                ])}

                {renderProtectedRoute("user-management", OrganizationUsers, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "user-management/import-users",
                  () => (
                    <ImportUsersPage isMapping={false} />
                  ),
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "user-management/import-users/mapping",
                  () => (
                    <ImportUsersPage isMapping={true} />
                  ),
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "user-management/user-details",
                  UserDetailPage,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "user-management/user-details/view/:formId",
                  UserAssignFormDetail,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "projects/standard-forms/form-assignment/view/:formId",
                  UserAssignFormDetail,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "user-management/roles-and-permissions",
                  RolesPage,
                  ["organisation"],
                )}
                {renderProtectedRoute("user-management/profile", Profile, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "user-management/license-access",
                  Profile,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "user-management/location-user",
                  LocationUser,
                  ["organisation"],
                )}

                {renderProtectedRoute("assigned-form", AssignedForms, [
                  "organisation",
                ])}
                {renderProtectedRoute("manage-forms", ManageForms, [
                  "organisation",
                ])}

                {renderProtectedRoute("projects/dynamic-forms", DynamicForm, [
                  "organisation",
                ])}

                {renderProtectedRoute(
                  "projects/standard-forms/view/:formId",
                  ViewStandardForm,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "projects/standard-forms/action/:formId",
                  StandardFormAction,
                  ["organisation"],
                )}

                {renderProtectedRoute(
                  "projects/dynamic-forms/viewdynamic-form/:formId",
                  ViewDynamicForm,
                  ["organisation"],
                )}

                {renderProtectedRoute("dynamic-forms/edit", EditDynamicForm, [
                  "organisation",
                ])}
                {renderProtectedRoute("projects/standard-forms", StandardForm, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "projects/standard-forms/hierarchy/:id",
                  HierarchyPage,
                  ["organisation"],
                )}
                {renderProtectedRoute("my-question-bank", YourQuestion, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "my-question-bank/sub-section",
                  SubSections,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "my-question-bank/sub-section/divisions",
                  Divisions,
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "my-question-bank/sub-section/questions",
                  Questions,
                  ["organisation"],
                )}
                {renderProtectedRoute("organization-setup", OrganizationSetup, [
                  "organisation",
                ])}
                {renderProtectedRoute(
                  "organization-setup/import-location",
                  () => (
                    <ImportLocationPage isMapping={false} />
                  ),
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "organization-setup/import-location/mapping",
                  () => (
                    <ImportLocationPage isMapping={true} />
                  ),
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "organization-setup/import-department",
                  () => (
                    <ImportDepartmentPage isMapping={false} />
                  ),
                  ["organisation"],
                )}
                {renderProtectedRoute(
                  "organization-setup/import-department/mapping",
                  () => (
                    <ImportDepartmentPage isMapping={true} />
                  ),
                  ["organisation"],
                )}
                {renderProtectedRoute("support", Support, ["organisation"])}

                {renderProtectedRoute(
                  "support/create-new-tickets",
                  CreateNewTickets,
                  ["organisation"],
                )}
                {renderProtectedRoute(`support/chat/:ticketId`, SupportAction, [
                  "organisation",
                ])}
              </Route>
              <Route
                path="/"
                element={
                  isLoggedIn ? (
                    <Navigate to="/organization/dashboard" />
                  ) : (
                    <Navigate to="/organization/login" />
                  )
                }
              />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </Content>
        </ErrorBoundary>
      </Layout>

      {/* Footer for Employee Routes and Other Non-Organization Routes */}
      {/* {shouldShowFooter && (
        <div className="mt-0 bg-white">
          <Footer />
        </div>
      )} */}
      {sessionExpired && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md animate-fadeIn">
          <PopupCard
            type="warning"
            title="Session Expired"
            message="Your session has expired due to inactivity. For security reasons, please sign in again to continue using CARBURN."
            confirmText="Sign In Again"
            onConfirm={() => {
              const isEmployee =
                localStorage.getItem("employeeLogin") === "true";
              const orgId = localStorage.getItem("orgId");

              dispatch(logout());
              dispatch(setSessionExpired(false));

              if (isEmployee && orgId) {
                window.location.href = `/employee/login/${orgId}`;
              } else {
                window.location.href = "/organization/login";
              }
            }}
          />
        </div>
      )}
    </ConfigProvider>
  );
}

export default App;
